import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  deleteCookie(event) {
    document.cookie = `${event.params.cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }
}
